import "./tooltip.css";
import { $ as e } from "./mergeProps-F8wVfzJL.mjs";
import o from "react";
import { TooltipTrigger as p, Button as f, Tooltip as u } from "react-aria-components";
import _ from "./icon.mjs";
import { Gray as b } from "./colors.mjs";
const d = "_button_louwr_1", $ = "_icon_louwr_17", E = "_tooltip_louwr_21", t = {
  button: d,
  icon: $,
  tooltip: E
};
function D({
  icon: r,
  iconColor: n,
  children: i,
  label: l,
  tooltipProps: c,
  buttonProps: a
}) {
  const m = e(a, {
    "aria-label": l || "more information",
    className: t.button
  }), s = e(c, {
    className: t.tooltip,
    offset: 4
  });
  return /* @__PURE__ */ o.createElement(p, { delay: 0 }, /* @__PURE__ */ o.createElement(f, { ...m }, /* @__PURE__ */ o.createElement(
    _,
    {
      icon: r || "InfoCircle",
      color: n || b.$800,
      "aria-hidden": !0,
      className: t.icon
    }
  )), /* @__PURE__ */ o.createElement(u, { ...s }, i));
}
export {
  D as default
};
